import { createFileRoute } from '@tanstack/react-router'

import i18n from '@/i18n'
import { StudentEditView } from '@/modules/students'
import { getMetaWithPageTitle } from '@/utils/get-page-title'

export const Route = createFileRoute(
  '/_auth/students-and-classes/students/edit/$studentId'
)({
  component: StudentEditView,
  head: () =>
    getMetaWithPageTitle([i18n.t('title.edit-student', { ns: 'students' })])
})
